/**
 * Base URL for the Sisi ni Tanzania website
 * Used for canonical links, SEO, and structured data
 */
export const BASE_URL = 'https://www.sisinitanzania.co.tz';

/**
 * Get the full URL for a given path
 * @param path - The path (e.g., '/blog', '/events/123')
 * @returns Full URL (e.g., 'https://www.sisinitanzania.co.tz/blog')
 */
export const getFullUrl = (path: string): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_URL}${cleanPath}`;
};

